import { isEmpty, reject } from 'ramda'

import { isEmptyOrNil } from 'libs/empty'

import { EVERYONE, SUBSCRIBER_WITHOUT_GROUP } from 'app/constants/recipient'

export const handleOptionsFilterGroups = (options = []) => {
  if (isEmptyOrNil(options)) return []

  const groups = []
  let withoutGroup = {}

  for (const item of options) {
    if (item.type === EVERYONE) {
      continue
    } else if (item.type === SUBSCRIBER_WITHOUT_GROUP) {
      withoutGroup = item
    } else {
      groups.push(item)
    }
  }

  return reject(isEmpty, [withoutGroup, ...groups])
}

export const reduceArrToObj = (options = []) => {
  const initialState = {}

  if (isEmptyOrNil(options)) return initialState
  else {
    options?.forEach((option) => {
      initialState[option.id] = {
        ...option,
        parentChecked: false,
        indeterminateParent: false,
        tags: option?.tags?.reduce((acc, tag) => {
          acc[tag.id] = { ...tag, childrenChecked: false }
          return acc
        }, {}),
      }
    })
    return initialState
  }
}
